<template>
  <qc-dialog class="tc-15-rich-dialog cos cos-ud-task-dialog operate-dialog" :show="innerShow" type="custom"
    :width="900" @close="closeDialog" :default-cancel="false" :append-to-body="true" :close-triggers="[]">

    <qc-button type="icon" :title="$t('cos.close')" class="operate-dialog-close" @click="closeDialog">
      <qc-icon type="close"></qc-icon>
    </qc-button>

    <div class="cos-ud-task-dialog-tab">
      <ul class="cos-ud-task-dialog-tab-list">
        <li :class="{'active':'upload'===tabActive}" @click="tabActive='upload'">
          <i class="icon upload-icon"></i>
          <span class="title">{{$t('cos.upload')}}</span>
          <span class="quantity" v-show="uploadNum!==0">{{uploadNum}}</span>
        </li>
        <!-- <li :class="{'active':'download'===tabActive}" @click="tabActive='download'">
          <i class="icon download-icon"></i>
          <span class="title">{{$t('core.download')}}</span>
          <span class="quantity" v-show="downloadNum!==0">{{downloadNum}}</span>
        </li> -->
      </ul>
      <div class="cos-ud-task-dialog-tool">
        <div class="tc-action-grid">
          <div class="justify-grid">
            <div class="col">
              <button class="tc-15-btn m weak" :class="{'disabled': disabledBtn.select}"
                @click="doTaskAction('pauseTask')">{{$t('cos.pause')}}</button>
              <button class="tc-15-btn m weak" :class="{'disabled': disabledBtn.select}"
                @click="doTaskAction('restartTask')">{{$t('cos.start')}}</button>
              <button class="tc-15-btn m weak" :class="{'disabled': disabledBtn.select}"
                @click="doTaskAction('cancelTask')">{{$t('cos.delete')}}</button>
              <button class="tc-15-btn m weak" :class="{'disabled': disabledBtn.all}"
                @click="removeFinishTask()">{{$t('cos.clear_completed')}}</button>

              <qc-dropdown type="button" trigger="hover" class="custom-dropdown-menu" :close-on-click="true">
                <template>
                  {{$t('cos.more')}}
                </template>
                <template slot="dropdown">
                  <qc-dropdown-item :disabled="disabledBtn.all" @click="pauseAllTask">
                    <span class="align-middle">{{$t('cos.pause_all')}}</span>
                  </qc-dropdown-item>
                  <qc-dropdown-item :disabled="disabledBtn.all" @click="restartAllTask">
                    <span class="align-middle">{{$t('cos.start_all')}}</span>
                  </qc-dropdown-item>
                  <qc-dropdown-item :disabled="disabledBtn.all" @click="removeAllTask">
                    <span class="align-middle">{{$t('cos.delete_all')}}</span>
                  </qc-dropdown-item>
                </template>
              </qc-dropdown>
            </div>
            <div class="col">
              <label class="form-ctrl-label mr-10">
                <input class="tc-15-checkbox" type="checkbox" v-model="showDoing"
                  :value="true">{{$t('cos.uploading')}}
              </label>
              <label class="form-ctrl-label mr-10">
                <input class="tc-15-checkbox" type="checkbox" v-model="showError"
                  :value="true">{{$t('cos.upload_failed_text')}}
              </label>
              <label class="form-ctrl-label mr-10">
                <input class="tc-15-checkbox" type="checkbox" v-model="showFinish"
                  :value="true">{{$t('cos.upload_success_text')}}
              </label>

            </div>
          </div>
        </div>
      </div>
      <div class="cos-ud-task-dialog-tab-content">
        <div class="tc-panel panel-table">
          <upload ref="upload" v-show="tabActive==='upload'" :disable-btn.sync="uploadDisableBtn"
            :filter="{showDoing,showError,showFinish}" @close="closeDialog"></upload>
          <!-- <download ref="download" v-show="tabActive==='download'" :disable-btn.sync="downloadDisableBtn"
            :filter="{showDoing,showError,showFinish}" @close="closeDialog">
          </download> -->
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { getInnerProps } from 'tools/utils';
import device from 'current-device';
import upload from './upload';

export default {
  components: {
    upload,
  },
  props: {
    show: {
      required: true,
      default: false,
    },
  },
  data() {
    return {
      tabActive: 'upload',
      uploadDisableBtn: {
        select: true,
        all: true,
      },
      downloadDisableBtn: {
        select: true,
        all: true,
      },
      showDoing: true,
      showError: true,
      showFinish: true,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    disabledBtn() {
      if (this.tabActive === 'upload') {
        return this.uploadDisableBtn;
      }
      return this.downloadDisableBtn;
    },
    uploadNum() {
      return this.$store.uploadNum;
    },
    currentPanel() {
      return this.$refs[this.tabActive];
    },
    downloadNum() {
      return this.$store.downloadNum;
    },
    isMobile() {
      return device.mobile();
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.tabActive = 'upload';
      }
    },
  },
  methods: {
    doTaskAction(action) {
      if (this.disabledBtn.select) return;
      this.currentPanel.doTaskAction(action);
    },
    removeFinishTask() {
      if (this.disabledBtn.all) return;
      this.currentPanel.removeFinishTask();
    },
    pauseAllTask() {
      if (this.disabledBtn.all) return;
      this.currentPanel.pauseAllTask();
    },
    restartAllTask() {
      if (this.disabledBtn.all) return;
      this.currentPanel.restartAllTask();
    },
    removeAllTask() {
      if (this.disabledBtn.removeAll) return;
      this.currentPanel.removeAllTask();
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$xs: 360px;
$sm: 600px;
$md: 768px;
.tc-15-rich-dialog {
  ::v-deep .dialog__container {
    @media screen and (max-width: $sm) {
      // width: 100%;
      .tc-15-rich-dialog {
        .cos-ud-task-dialog-tool {
          padding: 18px 15px 8px;
          .tc-action-grid {
            .justify-grid {
              .col {
                display: flex;
                justify-content: space-evenly;
                margin-bottom: 8px;
                .tc-15-btn {
                  padding: 0 10px;
                }
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: $md) {
      .tc-15-rich-dialog {
        width: 100% !important;
      }
    }
  }
}
</style>
